module.exports = __webpack_public_path__ + "static/img/1959_08_13_AnticMeet_Program_3.c8af941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_08_13_AnticMeet_Program_3.jpg
// module id = cyt1
// module chunks = 0